module.exports = __webpack_public_path__ + "static/media/eye-view.4b5e2d05.svg";